import {Injectable} from "@angular/core";
import {StorageKeysEnum} from "../../storage/storage-keys.enum";
import {Location} from "@angular/common";
import * as _ from "lodash";
import jwt_decode from "jwt-decode";

@Injectable({providedIn: 'root'})
export class RcpService {

    constructor(private location: Location) {
    }

    isTemporalPassword() {
        const monexAccessToken = sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN_WSO) || "";
        if (monexAccessToken && !_.isEmpty(monexAccessToken)) {
            const tokenDecode: any = jwt_decode(monexAccessToken);
            const {rcp} = tokenDecode;
            return rcp
        }
        return false;
    }
}
